export default __webpack_public_path__ + "static/lushootseed-sulad-webfont-7e223977f0e806f412c6f28c79260820.woff2";